(function () {
  'use strict';

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var finePointer = window.matchMedia('(pointer: fine)');

  if (reducedMotion.matches || !finePointer.matches) {
    return;
  }

  var colors = ['#232619', '#ce9c43'];
  var canvas = null;
  var context = null;
  var particles = [];
  var animationFrame = null;
  var lastFrameTime = 0;
  var lastEmitTime = 0;
  var dpr = 1;

  function randomBetween(min, max) {
    return min + Math.random() * (max - min);
  }

  function resizeCanvas() {
    if (!canvas || !context) {
      return;
    }

    dpr = Math.min(window.devicePixelRatio || 1, 2);
    canvas.width = Math.round(window.innerWidth * dpr);
    canvas.height = Math.round(window.innerHeight * dpr);
    canvas.style.width = window.innerWidth + 'px';
    canvas.style.height = window.innerHeight + 'px';
    context.setTransform(dpr, 0, 0, dpr, 0, 0);
  }

  function drawSparkle(particle) {
    var progress = particle.age / particle.life;
    var alpha = Math.max(1 - progress, 0);
    var size = particle.size * (1 - progress * 0.35);
    var inner = size * 0.35;

    context.save();
    context.translate(particle.x, particle.y);
    context.rotate(particle.rotation + progress * particle.spin);
    context.globalAlpha = alpha;
    context.fillStyle = particle.color;
    context.beginPath();
    context.moveTo(0, -size);
    context.lineTo(inner, -inner);
    context.lineTo(size, 0);
    context.lineTo(inner, inner);
    context.lineTo(0, size);
    context.lineTo(-inner, inner);
    context.lineTo(-size, 0);
    context.lineTo(-inner, -inner);
    context.closePath();
    context.fill();
    context.restore();
  }

  function animate(timestamp) {
    var delta = timestamp - (lastFrameTime || timestamp);
    lastFrameTime = timestamp;

    context.clearRect(0, 0, window.innerWidth, window.innerHeight);

    particles = particles.filter(function (particle) {
      particle.age += delta;

      if (particle.age >= particle.life) {
        return false;
      }

      particle.x += particle.vx * delta;
      particle.y += particle.vy * delta;
      particle.vy += particle.gravity * delta;
      drawSparkle(particle);

      return true;
    });

    if (particles.length > 0) {
      animationFrame = window.requestAnimationFrame(animate);
    } else {
      animationFrame = null;
      lastFrameTime = 0;
    }
  }

  function startAnimation() {
    if (!animationFrame) {
      animationFrame = window.requestAnimationFrame(animate);
    }
  }

  function emitSparkles(x, y) {
    var count = Math.floor(randomBetween(2, 5));

    for (var index = 0; index < count; index += 1) {
      particles.push({
        x: x + randomBetween(-6, 6),
        y: y + randomBetween(-6, 6),
        vx: randomBetween(-0.055, 0.055),
        vy: randomBetween(-0.12, -0.025),
        gravity: randomBetween(0.00012, 0.00022),
        size: randomBetween(3, 7),
        rotation: randomBetween(0, Math.PI),
        spin: randomBetween(-2.8, 2.8),
        age: 0,
        life: randomBetween(520, 920),
        color: colors[Math.floor(Math.random() * colors.length)]
      });
    }

    if (particles.length > 90) {
      particles.splice(0, particles.length - 90);
    }

    startAnimation();
  }

  function handleMouseMove(event) {
    var now = window.performance.now();

    if (now - lastEmitTime < 18) {
      return;
    }

    lastEmitTime = now;
    emitSparkles(event.clientX, event.clientY);
  }

  function createCanvas() {
    canvas = document.createElement('canvas');
    canvas.className = 'euco-cursor-sparkles';
    canvas.setAttribute('aria-hidden', 'true');
    canvas.style.position = 'fixed';
    canvas.style.inset = '0';
    canvas.style.pointerEvents = 'none';
    canvas.style.zIndex = '9998';
    canvas.style.width = '100vw';
    canvas.style.height = '100vh';
    canvas.style.display = 'block';

    document.body.appendChild(canvas);
    context = canvas.getContext('2d');
    resizeCanvas();

    window.addEventListener('resize', resizeCanvas, { passive: true });
    window.addEventListener('mousemove', handleMouseMove, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', createCanvas);
  } else {
    createCanvas();
  }
})();

// =====================================================================================================================================

// (function () {
//   var trail = [];
//   var max = 12;

//   var canvas = document.createElement('canvas');
//   var ctx = canvas.getContext('2d');

//   Object.assign(canvas.style, {
//     position:'fixed',
//     inset:'0',
//     pointerEvents:'none',
//     zIndex:'9998'
//   });

//   document.body.appendChild(canvas);

//   function resize(){
//     canvas.width = innerWidth;
//     canvas.height = innerHeight;
//   }

//   resize();
//   window.addEventListener('resize', resize);

//   window.addEventListener('mousemove', e=>{
//     trail.push({
//       x:e.clientX,
//       y:e.clientY,
//       a:1
//     });

//     if(trail.length > max) trail.shift();
//   });

//   function draw(){
//     ctx.clearRect(0,0,innerWidth,innerHeight);

//     trail.forEach((p,i)=>{
//       p.a -= .03;

//       ctx.beginPath();
//       ctx.arc(
//         p.x,
//         p.y,
//         2 + i/3,
//         0,
//         Math.PI*2
//       );

//       ctx.fillStyle =
//         `rgba(206,156,67,${p.a})`;

//       ctx.fill();
//     });

//     requestAnimationFrame(draw);
//   }

//   draw();

// })();